import React, { InputHTMLAttributes } from "react"
import cn from "classnames"
import Icon from "../general/Icon"
import { t } from "../../i18n"

export interface OptionProps {
  i18nKey?: string;
  name?: string;
  value: number | string;
}

interface SelectProps {
  className?: string;
  disabled?: boolean;
  frequentlyChosenOptions?: OptionProps[];
  hasHeader?: boolean;
  hasLabel?: boolean;
  i18nKey?: string;
  input: InputHTMLAttributes<HTMLSelectElement>;
  options: OptionProps[];
  small?: boolean;
  withError?: boolean;
}

const Select: React.FC<SelectProps> = (props: SelectProps) => {
  const { disabled, frequentlyChosenOptions, i18nKey, input, options, small, withError, hasLabel = true } = props
  const className = cn("Input", props.className, {
    "Input--filled": input.value || input.value === 0,
    "Input--disabled": disabled,
    "Input--error": withError,
    "Input--small": small,
  })

  return (
    <label className={className}>
      {props.hasHeader && <span className="block text-sm font-semibold mb-2">{t(i18nKey)}</span>}
      <select {...input} disabled={disabled} className="Input-input Input-select">
        {frequentlyChosenOptions &&
          frequentlyChosenOptions.map(({ i18nKey, name, value }) =>
            <option key={value} value={value}>
              {name || t(i18nKey)}
            </option>
        )}
        {frequentlyChosenOptions &&
          <option disabled>_______________</option>
        }
        {options.map(({ i18nKey, name, value }) =>
          <option key={value} value={value}>
            {name || t(i18nKey)}
          </option>
        )}
      </select>
      {!props.hasHeader && hasLabel && <span className="Input-selectLabel">{t(i18nKey)}</span>}
      <Icon className="Input-selectIcon" symbolId="chevron-down"/>
    </label>
  )
}

export default Select
